import type { FaireProductEntity } from "../../entity_types/product";

export const p_atzvr48lkf: FaireProductEntity = {
  token: "p_atzvr48lkf",
  type: "product",
  name: "MUSCLE & JOINT PAIN CREAM | 4 OZ",
  brandToken: "b_5dagse75md",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/193b68cc574c87c931f821d89806b4185feb00405ddbd6355ecabd411c329bb7.png",
  galleryImageUrls: [],
  priceDollars: 24,
  description:
    "This cream is a must for achy muscles and joints. Great for relief after a hard workout or for alleviating joint inflammation.\n\nTO USE: Apply on sore muscles or joints as needed.\n\n⚠️ Please Note: Curcumin naturally provides the same effects as blood pressure and diabetes medications. Anyone with these conditions should take extra precaution. We recommend checking with your doctor before making any changes to your dietary routine.\n\nINGREDIENTS: RAW SHEA BUTTER, ORGANIC RAW UNREFINED COLD PRESSED COCONUT OIL, MENTHOL CRYSTALS, ORGANIC BEESWAX, ORGANIC ARROWROOT POWDER, ORGANIC LIPOSOMAL CURCUMIN EXTRACT, ORGANIC VEGETABLE GLYCERIN, ORGANIC LIPOSOMAL WILLOW BARK EXTRACT, ORGANIC LIPOSOMAL GINGER EXTRACT, CAYENNE POWDER, BLACK PEPPER, 100% PURE THERAPEUTIC GRADE ESSENTIAL OILS: EUCALYPTUS, COPAIBA, PEPPERMINT, LAVENDER, WINTERGREEN, HELICHRYSUM, CLOVE, CAMPHOR.\n*Always check with your doctor before using a new product or supplement if you have any questions or concerns.",
  tags: [],
  msrpDollars: 48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:11.205Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
